import { layers } from '@atlassian/jira-common-styles/src/main.tsx';
import type { UserPickerSelectStylesConfig } from './types.tsx';

export const defaultUserPickerStyles: UserPickerSelectStylesConfig = {
	menuPortal: (base) => ({
		...base,
		zIndex: String(layers.modal),
	}),
};
